import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Events, tracking } from '@lib';
import { useApplicationStore } from '@data';
import { Button, EditIcon, Paragraph } from '@quickmd-llc/design-system';
import { US_STATES } from '@constants';
import { useShallow } from 'zustand/shallow';
import { VisitTypeIds } from '@router/loaders/utils';

export default function SearchQuery(): JSX.Element {
  const { visitTypeId } = useParams();
  const { getServiceTypeByVisitTypeId, setUtmParameters, utmParameters } =
    useApplicationStore(
      useShallow((state) => ({
        getServiceTypeByVisitTypeId: state.getServiceTypeByVisitTypeId,
        setUtmParameters: state.setUtmParameters,
        utmParameters: state.utmParameters,
      })),
    );
  const stateCode = useApplicationStore((state) => state.stateCode);
  const stateName = useMemo(() => getStateName(stateCode), [stateCode]);
  const serviceType = getServiceTypeByVisitTypeId(visitTypeId);
  const navigate = useNavigate();

  function handleClick() {
    tracking.trackEvent(Events.CLICK_EDIT_VISIT_TYPE);
    // In case the user was deep linked here by a utm service param,
    // clear it out so they can pick other types of services if desired.
    setUtmParameters({ ...utmParameters, service: null });
    navigate(`/services?state=${stateCode}`);
  }

  const isAddictionTreatment = visitTypeId === VisitTypeIds.AddictionTreatment;

  return (
    <div
      className={`flex-0 flex ${isAddictionTreatment ? 'items-start' : 'items-center'}`}
    >
      <Button priority="tertiary" size="s" onClick={handleClick}>
        <EditIcon className="text-text-dark" />
      </Button>

      <div className={isAddictionTreatment ? 'pt-1.5' : ''}>
        <Paragraph className="font-medium text-text-dark">
          {serviceType?.name}{' '}
          <span className="font-normal text-text-light">in</span> {stateName}
        </Paragraph>

        {isAddictionTreatment && (
          <Paragraph className="text-text-medium" size="sm">
            Treatment for opioid, kratom, and 7{'\u2011'}OH dependency.
          </Paragraph>
        )}
      </div>
    </div>
  );
}

function getStateName(stateCode?: string): string {
  return (
    US_STATES.find((state) => state.abbreviation === stateCode)?.name || ''
  );
}
